import { createContext, useContext, useMemo, useState } from "react";

const GrapeListContext = createContext(null);

export const GrapeListProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedPopup, setSelectedPopup] = useState(null);
  const handlePopupOpen = () => {
    setPopupOpen(true);
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
  };

  const requestRemoveProduct = (product) => {
    setSelectedProduct(product);
    setRemoveDialogOpen(true);
  };

  const cancelRemoveProduct = () => {
    setSelectedProduct(null);
    setRemoveDialogOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const value = useMemo(() => {
    const handleClose = () => {
      setOpen(false);
    };
    const confirmRemoveProduct = () => {
      if (!selectedProduct) {
        return;
      }

      setProducts((prev) =>
        prev.filter((product) => product.id !== selectedProduct.id),
      );
      setSelectedProduct(null);
      setRemoveDialogOpen(false);
    };

    const initializeProducts = (products) => {
      setProducts(products);
    };
    const isSelected = (id) => products.some((product) => product.id === id);

    const addProduct = (product) => {
      setProducts((prev) => {
        if (prev.some((p) => p.id === product.id)) {
          return prev;
        }

        return [...prev, product];
      });
    };

    const addProducts = (items) => {
      setProducts((prev) => {
        const map = new Map(prev.map((p) => [p.id, p]));

        items.forEach((item) => map.set(item.id, item));

        return [...map.values()];
      });
    };

    const removeProduct = (id) => {
      setProducts((prev) => prev.filter((product) => product.id !== id));
    };

    const toggleProduct = (product) => {
      setProducts((prev) => {
        const exists = prev.some((p) => p.id === product.id);

        if (exists) {
          return prev.filter((p) => p.id !== product.id);
        }

        return [...prev, product];
      });
    };

    const clearProducts = () => setProducts([]);

    return {
      products,
      isSelected,
      addProduct,
      addProducts,
      removeProduct,
      toggleProduct,
      clearProducts,
      open,
      setOpen,
      handleClose,
      handleOpen,
      removeDialogOpen,
      selectedProduct,
      requestRemoveProduct,
      confirmRemoveProduct,
      cancelRemoveProduct,
      initializeProducts,
      popupOpen,
      handlePopupOpen,
      handlePopupClose,
      selectedPopup,
      setSelectedPopup,
    };
  }, [products, open, removeDialogOpen, popupOpen, selectedPopup, selectedProduct]);

  return (
    <GrapeListContext.Provider value={value}>
      {children}
    </GrapeListContext.Provider>
  );
};

export const useGrapeList = () => {
  const context = useContext(GrapeListContext);

  if (!context) {
    throw new Error("useGrapeList must be used inside GrapeListProvider");
  }

  return context;
};
